import { useState } from "react";
import { api } from "../../../../services";

export const useParamsFromTitle = () => {
  const [isFetchingParamsFromTitle, setIsFetchingParamsFromTitle] = useState(false)
  const fetchParamsFromTitle = async (title) => {
    setIsFetchingParamsFromTitle(true)
    try {
      const response = await api.Ads.fetchParamsFromTitle(title);
      setIsFetchingParamsFromTitle(false)
      return response
    } catch (error) {
      setIsFetchingParamsFromTitle(false)
      return null;
    }

  }


  return {
    fetchParamsFromTitle,
    isFetchingParamsFromTitle
  }
}


// WEBPACK FOOTER //
// ./src/containers/SelectModulePage/TitleWithModule/hooks/useParamsFromTitle.ts